import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

import Footer from "./Footer";
import Header from "./Header";
import PageLoader from "./PageLoader";
import Sidebar from "./Sidebar";

import "./AdminLayout.css";

const AdminLayout = () => {
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");

    const handleChange = (e) => {
      setIsMobile(e.matches);
      if (e.matches) setIsOpen(false);
      else setIsOpen(true);
    };

    setIsMobile(mq.matches);
    if (mq.matches) setIsOpen(false);

    mq.addEventListener("change", handleChange);
    return () => mq.removeEventListener("change", handleChange);
  }, []);

  return (
    <div className={`admin-layout${isOpen ? " sidebar-open" : " sidebar-closed"}`}>
      <Sidebar isOpen={isOpen} isMobile={isMobile} />

      {/* Overlay: sits BEHIND the sidebar (z-index 1200) but OVER the main content.
          Tapping it closes the sidebar. Only rendered on mobile when sidebar is open. */}
      {isMobile && isOpen && (
        <div
          className="admin-sidebar-overlay"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="admin-main">
        <Header toggleSidebar={() => setIsOpen((o) => !o)} />

        <main className="admin-content">
          {loading && <PageLoader />}
          <Outlet context={{ setLoading }} />
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default AdminLayout;